@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .tooltipBubble {
    font-family: var(--font-nort);
    background-color: var(--surface-default);
    padding: 8px 12px;
    @include border-radius-r1;
    @include typography-v2-body-sm;
    box-shadow: var(--elevation-strong);
    color: var(--text-default);
    max-width: 340px;
    overflow-wrap: break-word;
    white-space: normal;
    z-index: 1;
    text-align: left;
  }

  .tooltipBubbleNoMaxWidth {
    max-width: none;
  }

  .arrowIcon {
    position: absolute;
    background-color: var(--surface-default);
    width: 8px;
    height: 8px;
    transform: rotate(45deg);
    z-index: 1;
  }

  .mobileTapClose {
    display: block;
    @include typography-v2-ui-xs;
    margin-top: 4px;
    color: var(--text-disabled);
    text-transform: uppercase;
  }
}
